module.exports = __webpack_public_path__ + "static/media/goes-without-saying.8d94a74c.mp3";